export const iconFontAwesomeFoodBeverageMartiniGlass = (
	<i className="fa-solid fa-martini-glass"></i>
);
